import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../config/StateSchema";
import {BaseResponse} from "../../../../api/api";
import {IRoomsCollection} from "../../types/roomsTypes";
import {IChatsMyCollectionsQuery} from "../../../chats/types/chatsTypes";
import {snackbarAction} from "../../../errors/SnackbarSlice";

interface IResponse {
    collection: IRoomsCollection[] | null
}

export const fetchMyRoomsCollection = createAsyncThunk<IRoomsCollection[] | null,
    IChatsMyCollectionsQuery | void,
    ThunkConfig<string>>(
        'rooms/fetchMyChatsCollection',
        async (data, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            try {
                const response = await extra.api.get<BaseResponse<IResponse>>('room/my', {
                    params: data
                })

                if (!response.data.success) {
                    return rejectWithValue('error')
                }

                return response.data.response.collection
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                return rejectWithValue('error');
            }
        },
    );
